export default "__VITE_ASSET__Dsi_0Lvb__"